import agriculture_marker from "@reva/shared/assets/images/agriculture.svg";
import airport_marker from "@reva/shared/assets/images/airport.svg";
import bakery_marker from "@reva/shared/assets/images/bakery.svg";
import bank_marker from "@reva/shared/assets/images/bank.svg";
import bike_vehicle from "@reva/shared/assets/images/bike.svg";
import bus_stop_marker from "@reva/shared/assets/images/bus_stop.svg";
import cafe_marker from "@reva/shared/assets/images/cafe.svg";
import car_vehicle from "@reva/shared/assets/images/car.svg";
import center_marker from "@reva/shared/assets/images/center.svg";
import coordinates_marker from "@reva/shared/assets/images/coordinates.svg";
import doctors_marker from "@reva/shared/assets/images/doctors.svg";
import embassy_marker from "@reva/shared/assets/images/embassy.svg";
import firefighter_marker from "@reva/shared/assets/images/firefighter.svg";
import foot_vehicle from "@reva/shared/assets/images/foot.svg";
import forest_marker from "@reva/shared/assets/images/forest.svg";
import highway_junction_marker from "@reva/shared/assets/images/highway_junction.svg";
import hospital_marker from "@reva/shared/assets/images/hospital.svg";
import kindergarten_marker from "@reva/shared/assets/images/kindergarten.svg";
import mall_marker from "@reva/shared/assets/images/mall.svg";
import map_marker_marker from "@reva/shared/assets/images/map_marker.svg";
import motorway_link_marker from "@reva/shared/assets/images/motorway_link.svg";
import package_delivery_marker from "@reva/shared/assets/images/package_delivery.svg";
import park_marker from "@reva/shared/assets/images/park.svg";
import pharmacy_marker from "@reva/shared/assets/images/pharmacy.svg";
import playground_marker from "@reva/shared/assets/images/playground.svg";
import police_marker from "@reva/shared/assets/images/police.svg";
import post_office_marker from "@reva/shared/assets/images/post_office.svg";
import prison_marker from "@reva/shared/assets/images/prison.svg";
import railway_stop_marker from "@reva/shared/assets/images/railway_stop.svg";
import restaurant_marker from "@reva/shared/assets/images/restaurant.svg";
import scale_marker from "@reva/shared/assets/images/scale.svg";
import social_institution_marker from "@reva/shared/assets/images/social_institution.svg";
import sport_marker from "@reva/shared/assets/images/sport.svg";
import supermarket_marker from "@reva/shared/assets/images/supermarket.svg";
import theater_marker from "@reva/shared/assets/images/theater.svg";
import tram_stop_marker from "@reva/shared/assets/images/tram_stop.svg";
import waterway_marker from "@reva/shared/assets/images/waterway.svg";
import {POI_CATEGORY_TO_ICON_FILENAME} from "@reva/shared/poi";

import bike_vehicle_white from "../images/bike_white.svg";
import car_vehicle_white from "../images/car_white.svg";
import foot_vehicle_white from "../images/foot_white.svg";

export const FALLBACK_ICON = coordinates_marker;

// Filename -> bundled module, for every icon POI_CATEGORY_TO_ICON_FILENAME (shared) can point to.
const ICON_MODULE_BY_FILENAME = {
    "railway_stop.svg": railway_stop_marker,
    "tram_stop.svg": tram_stop_marker,
    "airport.svg": airport_marker,
    "motorway_link.svg": motorway_link_marker,
    "highway_junction.svg": highway_junction_marker,
    "hospital.svg": hospital_marker,
    "doctors.svg": doctors_marker,
    "pharmacy.svg": pharmacy_marker,
    "kindergarten.svg": kindergarten_marker,
    "bus_stop.svg": bus_stop_marker,
    "supermarket.svg": supermarket_marker,
    "mall.svg": mall_marker,
    "bakery.svg": bakery_marker,
    "bank.svg": bank_marker,
    "theater.svg": theater_marker,
    "cafe.svg": cafe_marker,
    "scale.svg": scale_marker,
    "embassy.svg": embassy_marker,
    "firefighter.svg": firefighter_marker,
    "map_marker.svg": map_marker_marker,
    "package_delivery.svg": package_delivery_marker,
    "park.svg": park_marker,
    "playground.svg": playground_marker,
    "police.svg": police_marker,
    "post_office.svg": post_office_marker,
    "prison.svg": prison_marker,
    "restaurant.svg": restaurant_marker,
    "waterway.svg": waterway_marker,
    "agriculture.svg": agriculture_marker,
    "forest.svg": forest_marker,
    "social_institution.svg": social_institution_marker,
    "sport.svg": sport_marker,
    "center.svg": center_marker,
};

export const POIS_CATEGORY_TO_ICON = Object.fromEntries(
    Object.entries(POI_CATEGORY_TO_ICON_FILENAME).map(([category, filename]) => [
        category,
        ICON_MODULE_BY_FILENAME[filename],
    ]),
);

export const POIS_VEHICLE_TO_ICON = {
    foot: foot_vehicle,
    bike: bike_vehicle,
    car: car_vehicle,
    foot_white: foot_vehicle_white,
    bike_white: bike_vehicle_white,
    car_white: car_vehicle_white,
};
